import React, { useEffect, useState } from 'react';
import { SO_PLANNING_SUMMARY_API } from '../../../config/api';

function SOPlanningCard({ userId, orgId, dateFrom, dateTo }) {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId || !orgId) return;

    const fetchPlanning = async () => {
      setLoading(true);
      try {
        const res = await fetch(SO_PLANNING_SUMMARY_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            user_id: userId,
            org_id: orgId,
            date_from: dateFrom,
            date_to: dateTo
          })
        });

        const data = await res.json();
        if (res.ok && data.success) {
          setSummary(data);
        } else {
          setSummary(null);
        }
      } catch (err) {
        setSummary(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPlanning();
  }, [userId, orgId, dateFrom, dateTo]);

  return (
    <div className="card shadow border-0 text-center">
      <div className="card-body">
        <h5 className="card-title">📋 SO Planning</h5>
        {loading ? (
          <p>Loading...</p>
        ) : summary ? (
          <>
            <h2 className="card-text">{summary.total_plans} Plans</h2>
            <p className="mb-1"><strong>Customers:</strong> {summary.customer_names}</p>
            <p className="mb-1"><strong>Materials:</strong> {summary.material_names}</p>
            <p className="mb-0"><strong>Total Qty:</strong> {summary.total_qty}</p>
          </>
        ) : (
          <p>No data found.</p>
        )}
      </div>
    </div>
  );
}

export default SOPlanningCard;
